export const Constants = {
    EMPTY_GUID: "00000000-0000-0000-0000-000000000000",
    DIALOG_SEVERITY_ERROR: 1,
    DIALOG_SEVERITY_WARNING: 2,
    DIALOG_SEVERITY_INFO: 3,
    DASHED_CELL_VALUE: '-',
    MARKET_RENT_ABBREVIATION_CELL_VALUE: 'MKT'
};